import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CloudDocumentService } from '../cloud-document.service';
import { ExternalContentProviders, ExternalContentProviderSource } from 'src/app/constants/ExternalContentProviders.enum';

@Component({
    selector: 'app-cloud-document-source-sidebar',
    templateUrl: './cloud-document-source-sidebar.component.html',
    styleUrls: ['./../cloud-document.modal.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloudDocumentSourceSidebarComponent implements OnInit, OnDestroy {
  private scrollSub!: Subscription;

  constructor(private cloudDocumentService: CloudDocumentService) {}

  ngOnInit() {
    this.scrollSub = this.cloudDocumentService.scrollToNode$.subscribe(id => {
      setTimeout(() => {
        document.getElementById('tree_' + id)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 50);
    });
  }

  ngOnDestroy() {
    this.scrollSub?.unsubscribe();
  }

  get hasSharePoint() { return this.cloudDocumentService.hasSharePoint; }
  get hasOneDrive()   { return this.cloudDocumentService.hasOneDrive; }
  get hasTeams()      { return this.cloudDocumentService.hasTeams; }
  get hasHyarchis()   { return this.cloudDocumentService.hasHyarchis; }
  get isNavigating()  { return this.cloudDocumentService.isNavigating; }
  get foldersForTree(){ return this.cloudDocumentService.getFoldersForTree(); }

  selectSharePoint() { this.cloudDocumentService.changeProvider(ExternalContentProviders.MsGraph, ExternalContentProviderSource.SharePoint); }
  selectOneDrive()   { this.cloudDocumentService.changeProvider(ExternalContentProviders.MsGraph, ExternalContentProviderSource.OneDrive); }
  selectTeams()      { this.cloudDocumentService.changeProvider(ExternalContentProviders.MsGraph, ExternalContentProviderSource.Teams); }
  selectHyarchis()   { this.cloudDocumentService.changeProvider(ExternalContentProviders.Hyarchis, ExternalContentProviderSource.Hyarchis); }

  isSharePointActive(): boolean { return this.cloudDocumentService.provider === ExternalContentProviders.MsGraph && this.cloudDocumentService.source === ExternalContentProviderSource.SharePoint; }
  isOneDriveActive():   boolean { return this.cloudDocumentService.provider === ExternalContentProviders.MsGraph && this.cloudDocumentService.source === ExternalContentProviderSource.OneDrive; }
  isTeamsActive():      boolean { return this.cloudDocumentService.provider === ExternalContentProviders.MsGraph && this.cloudDocumentService.source === ExternalContentProviderSource.Teams; }
  isHyarchisActive():   boolean { return this.cloudDocumentService.provider === ExternalContentProviders.Hyarchis && this.cloudDocumentService.isHyarchisSource; }

  isFolderActive(folderId: string)  { return this.cloudDocumentService.isFolderActive(folderId); }
  isFolderOpened(folderId: string)  { return this.cloudDocumentService.isFolderOpened(folderId); }

  onFolderClick(folder: any) {
    this.cloudDocumentService.showFolders(folder.parent, folder.id, folder.name);
    if (this.cloudDocumentService.isExportMode) this.cloudDocumentService.listenToFolderSelection();
  }
}
